import { useUpdateProjectFileStatus } from '@/features/review-project-file';

/**
 * Page-local adapter that wires the canonical `useUpdateProjectFileStatus`
 * mutation into the AssetDetail surface.
 *
 * Refactored from an inline useMutation into
 * a thin wrapper around `useUpdateProjectFileStatus`. Cache invalidation
 * (file detail + folder files + folder detail + folders list prefix) lives
 * in the canonical hook so any caller across the app gets the same shape.
 */
export function useApprovalStatus(projectId: string, folderId: string, fileId: string) {
  const mutation = useUpdateProjectFileStatus({ projectId, fileId, folderId });

  return {
    updateStatus: mutation.mutate,
    isUpdating: mutation.isPending,
  };
}
